<template>
  <section>
    <list
      :filter-table-key="'renew'"
      :type="4"></list>
  </section>
</template>

<script>
import list from '../policy/list'
export default {
  name: 'renew',
  components:{
    list
  },
}
</script>

<style scoped>

</style>
